import { NWG_API_PLAYGROUND_URL } from 'app/constants';
import React from 'react';
import { Card, View } from 'ui';

export function Playground() {
  return (
    <View
      iconClass="fas fa-toolbox"
      title="Playground"
      subTitle={'Follow link to Apollo studio to easily inspect schema.'}
    >
      <Card title="Sandbox">
        <p>Paste your applications token into an Authorization header inside sandbox:</p>
        <p>{`Authorization: Bearer {{token}}`}</p>
        <a
          target="_blank"
          href={`https://studio.apollographql.com/sandbox/explorer?endpoint=${NWG_API_PLAYGROUND_URL}`}
        >
          Apollo studio
        </a>
      </Card>
    </View>
  );
}

export default Playground;
